import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import Popup from '../../../../components/common-components/pop-up/Popup';
import CommonButton from '../../../../components/common-components/button/CommonButton';
import styles from './DeleteUserDialog.module.css';

const DeleteUserDialog: React.FC = () => {
  const { userManagementStore, popupStore } = useStore();
  const selectedUser = userManagementStore.selectedUser;

  const handleClose = () => {
    popupStore.setIsDeleteUserConfirmationOpen(false);
    userManagementStore.setSelectedUser(null);
  };

  const handleConfirm = async () => {
    if (selectedUser?.id) {
      try {
        await userManagementStore.deleteUser(selectedUser.id);
        handleClose();
      } catch (error) {
        console.error('Delete error:', error);
      }
    }
  };

  return (
    <Popup
      isOpen={popupStore.isDeleteUserConfirmationOpen}
      onClose={handleClose}
      title="Kullanıcı Silme Onayı"
    >
      <div className={styles.content}>
        <p className={styles.message}>
          <strong>{selectedUser?.userName}</strong> kullanıcısını silmek istediğinizden emin
          misiniz?
        </p>
        <p className={styles.warning}>Bu işlem geri alınamaz!</p>

        <div className={styles.buttons}>
          <CommonButton type="secondary" onClick={handleClose}>
            İptal
          </CommonButton>
          <CommonButton type="primary" onClick={handleConfirm}>
            Sil
          </CommonButton>
        </div>
      </div>
    </Popup>
  );
};

export default observer(DeleteUserDialog);
